import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="defaults"
export default class extends Controller {

  connect() {
    const notificationsElement = document.getElementById('notifications-id')
    if (notificationsElement) {
      setTimeout(() => {
        this.notificationsClose()
      }, 2000)
    }
  }

  notificationsClose() {
    const notificationsElement = document.getElementById('notifications-id')
    if (notificationsElement) {
      notificationsElement.style.transition = 'opacity 1s ease'
      notificationsElement.style.opacity = '0'
      setTimeout(() => {
        notificationsElement.remove()
      }, 1000)
    }
  }

  scrollToTop() {
    const turboFrame = document.querySelector(`turbo-frame#${this.element.dataset.modelName}_body`)
    if (turboFrame) {
      turboFrame.scrollIntoView({behavior: "smooth", block: "start"})
    }
  }

  syncEndDate(event) {
    const endDate = document.querySelector(event.target.dataset.targetSelector)
    if (!endDate) return
    if (!event.target.value) {
      endDate.value = ""
      return
    }

    const today = this.todayDateValue()
    endDate.value = event.target.value < today ? today : event.target.value
  }

  todayDateValue() {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, "0")
    const day = String(today.getDate()).padStart(2, "0")

    return `${year}-${month}-${day}`
  }

  submit() {
    if (typeof this.element.requestSubmit === 'function') {
      this.element.requestSubmit()
    }
  }

  download(event) {
    event.preventDefault()

    const form = event.currentTarget.form
    const downloadUrl = event.currentTarget.dataset.defaultsDownloadUrl
    if (!form || !downloadUrl) return

    const url = new URL(downloadUrl, window.location.origin)
    const formData = new FormData(form)

    for (const [key, value] of formData.entries()) {
      if (value !== "") {
        url.searchParams.append(key, value)
      }
    }

    window.location.href = url.toString()
  }

  orderValidate(event) {
    event.preventDefault()

    const companyId = document.getElementById('order_company_id')
    const orderName = document.getElementById('order_name')

    // 기본 공급자 정보 검증
    if (!companyId || !orderName || !companyId.value.trim() || !orderName.value.trim()) {
      alert("공급자 정보를 선택 해주세요")
      return
    }

    let isValid = true

    // 다이나믹 폼 필드 검증
    const dynamicFields = document.querySelectorAll('input[id^="order_order_infos_attributes_"][id$="_item_id"], ' + 'input[id^="order_order_infos_attributes_"][id$="_cost_price"], ' + 'input[id^="order_order_infos_attributes_"][id$="_sale_price"], ' + 'input[id^="order_order_infos_attributes_"][id$="_quantity"]')

    // 다이나믹 필드가 없는 경우 처리
    if (!dynamicFields || dynamicFields.length === 0) {
      alert("추가된 상품이 없습니다 상품을 추가해주세요")
      return
    }

    dynamicFields.forEach((field) => {
      if (!field.value.trim()) {
        isValid = false
      } else {
      }
    })

    if (isValid) {
      event.target.submit()
    } else {
      alert("모든 필수 필드를 입력해주세요")
    }
  }

  toggleSingle(e) {
    const hidden = document.getElementById("single-hidden")
    if (hidden) hidden.value = e.target.checked
  }
}
